<template>
    <span class="coorditate-buttons">
        <button type="button" class="fa fa-minus" @click="$emit('remove')" v-bind:title="'Удалить ' + title" v-if="canRemove"></button>
        <button type="button" class="fa fa-plus" @click="$emit('add')" v-bind:title="'Добавить ' + title" v-if="canAdd"></button>
    </span>
</template>

<script>
    export default {
        props: ['title', 'canAdd', 'canRemove']
    }
</script>



// WEBPACK FOOTER //
// CoordinateListButtons.vue?2f4e49ba